module.exports = __webpack_public_path__ + "static/left-img-114cef93e9a2062c4c903de15304a167.png";